module.exports = __webpack_public_path__ + "img/MIA_w_trans.fd24d166.png";